import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate } from '../../../../../utils/util';
import BackButton from '../../../../../components/UI/BackButton';
import LotItemMappedDetail from './LotItemMappedDetail';
import LotItemDetail from './LotItemDetail';
import { ENUMS } from '../../../../../utils/constants';

const LotItemGeneral = (props) => {
    const drone = props.location?.state?.lotOriginId === ENUMS.eInventoryOriginCount.Drone.value;
    const mapped = props.filter.lotMapped || props.filter.lotOriginId === ENUMS.eInventoryOriginCount.Drone.value || drone;

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('inventory', 'inventory')}
                    </div>
                    <div className="subtitle">
                        | <i className="mdi mdi-clipboard-list" />
                        {translate('general.filterByLotItem', 'inventory')}
                    </div>
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '30px', }}>
                {
                    mapped ? <LotItemMappedDetail /> : <LotItemDetail />
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(LotItemGeneral)));
